import React, { useEffect, useImperativeHandle, useRef, useState } from "react"
import PropTypes from "prop-types"

import { Container, CardBody, Card, Table, Col, Row, Button } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { FaDownload } from "react-icons/fa"
import { FaWhatsapp } from "react-icons/fa"

import MetaTag from "components/Common/Meta-tag"
import { useParams } from "react-router-dom/cjs/react-router-dom.min"
import { useDispatch, useSelector } from "react-redux"
import { getInspectionDetails, putWhatsappSharePdf } from "store/actions"
import downloadBanner from "assets/images/other/formHeader.png"
import verified from "assets/images/other/verified.png"

import Spinner from "components/Common/Spinner"
import { InspectionDocumentsParameters } from ".././Crud/parameters"
import moment from "moment"
import InspectionPDFDownload from "./pdf"

const InspectionDocumentDetails = props => {
  const dispatch = useDispatch()
  const params = useParams()
  const [isDownloading, setIsDownloading] = useState(false)
  const [pdfModalVisible, setPdfModalVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const isTablet = window.innerWidth <= 768

  const { loading, inspectionDetails } = useSelector(state => ({
    loading: state.Inspection?.loading,
    inspectionDetails: state.Inspection?.inspectionDetails,
  }))

  useEffect(() => {
    dispatch(getInspectionDetails(params.id))
  }, [params.id])

  const inspectionSections = [
    {
      title: "1. Vehicle History",
      data: InspectionDocumentsParameters?.vehicleHistory?.items,
      checkMetricIndex: 0,
      isSub: false,
    },
    {
      title: "2. Road Test",
      data: InspectionDocumentsParameters?.roadTest?.items,
      checkMetricIndex: 1,
      isSub: false,
    },
    {
      title: "3. Vehicle Exterior",
      data: InspectionDocumentsParameters?.vehicleExterior?.subHeads,
      checkMetricIndex: 2,
      isSub: true,
    },
    {
      title: "4. Vehicle Interior",
      data: InspectionDocumentsParameters?.vehicleInterior?.subHeads,
      checkMetricIndex: 3,
      isSub: true,
    },
    {
      title: "5. Vehicle Diagnostic",
      data: InspectionDocumentsParameters?.vehicleDiagnostics?.items,
      checkMetricIndex: 4,
    },
    {
      title: "6. Underhood Components",
      data: InspectionDocumentsParameters?.underhoodComponents?.subHeads,
      checkMetricIndex: 5,
      isSub: true,
    },
    {
      title: "7. UnderBody Components",
      data: InspectionDocumentsParameters?.underbodyComponents?.subHeads,
      checkMetricIndex: 6,
      isSub: true,
    },
    {
      title: "8. Final Check",
      data: InspectionDocumentsParameters?.finalChecks?.items,
      checkMetricIndex: 7,
      isSub: false,
    },
  ]
  const pdfComponentRef = useRef()

  const getGlobalIndex = (sectionIdx, subHeadIdx, itemIdx) => {
    let count = 0
    for (let i = 0; i < sectionIdx; i++) {
      const sec = inspectionSections[i]
      if (sec.isSub && Array.isArray(sec.data)) {
        sec.data.forEach(sub => {
          count += sub.item.length
        })
      } else if (Array.isArray(sec.data)) {
        count += sec.data.length
      }
    }
    // Add previous subHeads in this section
    if (subHeadIdx !== undefined) {
      for (let j = 0; j < subHeadIdx; j++) {
        count +=
          sectionIdx >= 0 && inspectionSections[sectionIdx].data[j].item.length
      }
      count += itemIdx
    } else {
      count += itemIdx
    }
    return count + 1
  }

  useImperativeHandle(pdfComponentRef, () => ({
    openPreviewModal: () => setIsPdfModalOpen(true),
  }))

  return (
    <React.Fragment>
      <div className="page-content mb-0 pb-2">
        <MetaTag title="Inspection Document Detail" />

        <Container fluid>
          <Breadcrumbs
            title="Inspection"
            breadcrumbItem="Inspection Document Detail"
          />

          <Card>
            <CardBody style={{ paddingTop: "0px !important" }}>
              {loading ? (
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{ height: "300px" }}
                >
                  <Spinner color="info" className="text-info font-size-20" />
                </div>
              ) : (
                <>
                  <div>
                    <Container
                      fluid
                      id="pdf-content"
                      className="no-print"
                      style={{ backgroundColor: "#fff" }}
                    >
                      {/* Header Banner */}
                      <div className="no-print">
                        <Row
                          className={`align-items-center g-1 ${inspectionDetails?.pdf_url?.url
                            ? "justify-content-between"
                            : "justify-content-end"
                            }`}
                        >
                          {inspectionDetails?.pdf_url?.url && (
                            <Col
                              md="auto"
                              className="d-flex flex-column align-items-center mt-2"
                            >
                              <Button
                                onClick={() =>
                                  dispatch(
                                    putWhatsappSharePdf(
                                      inspectionDetails?._id,
                                      setIsLoading,
                                      inspectionDetails?.inspection_data
                                        ?.inspection_number
                                    )
                                  )
                                }
                                style={{
                                  background: "#25D366",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "50px",
                                  padding: "5px 15px",
                                  fontSize: "12px",
                                  fontWeight: 600,
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  transition:
                                    "background 0.2s, box-shadow 0.2s",
                                  textShadow: "0 1px 2px rgba(0,0,0,0.3)",
                                }}
                                className="whatsapp-share-btn hvr-box-shadow-outset"
                              >
                                {isLoading ? (
                                  <>
                                    <Spinner
                                      size="sm"
                                      color="light"
                                      style={{
                                        width: "14px",
                                        height: "14px",
                                        marginRight: "6px",
                                      }}
                                    />{" "}
                                    Sending Inspection Report ...
                                  </>
                                ) : (
                                  <>
                                    <FaWhatsapp
                                      size={20}
                                      style={{ marginRight: 8 }}
                                    />
                                    WhatsApp Inspection Report
                                  </>
                                )}
                              </Button>
                              <div
                                style={{ textAlign: "center", marginTop: 6 }}
                              >
                                {inspectionDetails?.last_sent_at_whatsapp ? (
                                  <span
                                    style={{
                                      color: "grey",
                                      fontWeight: 500,
                                      fontSize: "12px",
                                    }}
                                  >
                                    Last shared on{" "}
                                    {moment(
                                      inspectionDetails.last_sent_at_whatsapp
                                    ).format("DD/MM/YYYY HH:mm")}
                                  </span>
                                ) : (
                                  <span
                                    style={{
                                      color: "#dc3545",
                                      fontWeight: 500,
                                      fontSize: "12px",
                                    }}
                                  >
                                    Not shared with client
                                  </span>
                                )}
                              </div>
                            </Col>
                          )}
                          <Col
                            className="justify-content-end"
                            xs="auto"
                            md="12"
                            lg="auto"
                            style={{ display: "flex", gap: "8px" }}
                          >
                            {inspectionDetails?.pdf_url?.url && (
                              <Button
                                onClick={async () => {
                                  setIsDownloading(true) // Start loading

                                  try {
                                    const response = await fetch(
                                      inspectionDetails.pdf_url.url,
                                      {
                                        mode: "cors",
                                      }
                                    )

                                    const blob = await response.blob()
                                    const url = window.URL.createObjectURL(blob)

                                    const link = document.createElement("a")
                                    const bookingId =
                                      inspectionDetails?.inspection
                                        ?.booking_id || "Report"
                                    const fileName = `Inspection_${bookingId}.pdf`

                                    link.href = url
                                    link.download = fileName
                                    document.body.appendChild(link)
                                    link.click()
                                    document.body.removeChild(link)
                                    window.URL.revokeObjectURL(url)
                                  } catch (err) {
                                    console.error("Download failed:", err)
                                  } finally {
                                    setIsDownloading(false) // Stop loading
                                  }
                                }}
                                color="success"
                                className="rounded-pill px-4"
                                disabled={isDownloading}
                              >
                                {isDownloading ? (
                                  <>
                                    <Spinner size="sm" className="me-2" />
                                    Downloading Report...
                                  </>
                                ) : (
                                  <>
                                    <FaDownload className="me-1" />
                                    Download Inspection Report
                                  </>
                                )}
                              </Button>
                            )}
                            {inspectionDetails && (
                              <InspectionPDFDownload
                                inspectionDetails={inspectionDetails || {}}
                                setPdfModalVisible={setPdfModalVisible}
                                pdfModalVisible={pdfModalVisible}
                              />
                            )}
                          </Col>
                        </Row>
                        <div
                          className="d-flex align-items-center text-center "
                          style={{ marginTop: "1px" }}
                        >
                          <hr className="flex-grow-1 solid-line" />
                        </div>
                      </div>
                      <Row className="align-items-center mb-4">
                        <Col md="12 ">
                          <img
                            src={downloadBanner}
                            alt="Focus Motors Banner"
                            style={{ maxWidth: "100%", height: "auto" }}
                          />
                        </Col>
                      </Row>

                      {/* Inspection Info */}
                      <Row className="mb-3">
                        <Col md="3">
                          <div>
                            <span className="grey-color fw-light">
                              Inspection Date
                            </span>
                          </div>
                          <div className="text-black">
                            {inspectionDetails?.inspection_data?.inspected_date
                              ? moment(
                                inspectionDetails.inspection_data
                                  .inspected_date
                              ).format("DD/MM/YYYY")
                              : "---"}
                          </div>{" "}
                        </Col>
                        <Col md="3">
                          <div>
                            <span className="grey-color fw-light">
                              Inspection No.{" "}
                            </span>
                          </div>
                          <div className="text-black">
                            {" "}
                            {inspectionDetails?.inspection_data
                              ?.inspection_number || "---"}
                          </div>{" "}
                        </Col>
                        <Col md="3">
                          <div>
                            <span className="grey-color fw-light">
                              Inspected By{" "}
                            </span>
                          </div>
                          <div className="text-black">
                            {" "}
                            {inspectionDetails?.inspection_data?.inspected_by
                              ?.name || "---"}
                          </div>{" "}
                        </Col>
                        <Col md="3">
                          <div>
                            <span className="grey-color fw-light">
                              Booking No.{" "}
                            </span>
                          </div>
                          <div className="text-black">
                            {" "}
                            {inspectionDetails?.booking_id || "---"}
                          </div>{" "}
                        </Col>
                      </Row>

                      {/* Vehicle & Owner Data */}
                      <Row className="mb-4">
                        <Col md="8">
                          <h6 className="bg-light p-2">VEHICLE DATA</h6>
                          <Table
                            borderless
                            size="sm"
                            className="table white-cell"
                          >
                            <tbody>
                              <tr>
                                <td>
                                  <span className="grey-color">
                                    Vehicle Brand :
                                  </span>
                                </td>
                                <td
                                  className="text-end text-black"
                                  style={{ marginRight: "20px" }}
                                >
                                  {inspectionDetails?.vehicle_data
                                    ?.vehicle_brand?.name || "---"}
                                </td>
                                <td style={{ width: "40px" }}></td>

                                <td>
                                  <span className="grey-color">Reg. No. :</span>
                                </td>
                                <td className="text-end text-black">
                                  {inspectionDetails?.vehicle_data
                                    ?.vehicle_number || "---"}
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <span className="grey-color">
                                    Vehicle Model :
                                  </span>
                                </td>
                                <td className="text-end text-black">
                                  {inspectionDetails?.vehicle_data
                                    ?.vehicle_model?.name || "---"}{" "}
                                </td>
                                <td style={{ width: "40px" }}></td>

                                <td>
                                  <span className="grey-color">Year :</span>
                                </td>
                                <td className="text-end text-black">
                                  {inspectionDetails?.vehicle_data
                                    ?.vehicle_year || "--"}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span className="grey-color">
                                    Vehicle Variant :
                                  </span>
                                </td>
                                <td className="text-end text-black">
                                  {inspectionDetails?.vehicle_data
                                    ?.vehicle_variant?.name || inspectionDetails?.vehicle_data?.variant_name || "---"}{" "}
                                </td>
                                <td style={{ width: "40px" }}></td>

                                <td>
                                  <span className="grey-color">KM :</span>
                                </td>
                                <td className="text-end text-black">
                                  {inspectionDetails?.vehicle_data
                                    ?.current_kilometer || "---"}
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <span className="grey-color"></span>
                                </td>
                                <td className="text-end text-black"></td>
                                <td style={{ width: "40px" }}></td>

                                <td style={{}}>
                                  <span className="grey-color">Fuel :</span>
                                </td>
                                <td className="text-end text-black">
                                  {inspectionDetails?.vehicle_data
                                    ?.vehicle_fuel_type || "---"}
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </Col>

                        <Col md="4">
                          <h6 className="bg-light p-2">OWNER DATA</h6>
                          <Table
                            borderless
                            size="sm"
                            className="table white-cell"
                          >
                            <tbody>
                              <tr>
                                <td>
                                  <span className="grey-color"> Name:</span>
                                </td>
                                <td className="text-end text-black">
                                  {inspectionDetails?.owner_details
                                    ?.customer_name || "---"}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span className="grey-color"> Phone:</span>
                                </td>
                                <td className="text-end text-black">
                                  {inspectionDetails?.owner_details
                                    ?.phone_number || "---"}{" "}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span className="grey-color"> State:</span>
                                </td>
                                <td className="text-end text-black">
                                  {inspectionDetails?.owner_details?.state
                                    ?.name || "---"}{" "}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span className="grey-color"> District:</span>
                                </td>
                                <td className="text-end text-black">
                                  {inspectionDetails?.owner_details?.district
                                    ?.name || "---"}{" "}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span className="grey-color"> Address:</span>
                                </td>
                                <td className="text-end text-black">
                                  {inspectionDetails?.owner_details?.address ||
                                    "---"}{" "}
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </Col>
                      </Row>

                      {/* Other Details */}
                      <Row>
                        <Col md="12">
                          <h6 className="bg-light p-2">OTHER DETAILS</h6>
                          <Row>
                            <Col md={6}>
                              <div>
                                <span className="grey-color fw-light">
                                  Finance{" "}
                                </span>
                              </div>
                              <div className="text-black">
                                {" "}
                                <span
                                  style={{
                                    display: "inline-block",
                                    background: "#d6f4f9",
                                    color: "#006c9c",
                                    borderRadius: "10px",
                                    marginTop: "5px",
                                    padding: "0.25em 1em",
                                    fontWeight: 500,
                                    fontSize: "1em",
                                  }}
                                >
                                  {/* yes */}
                                  {inspectionDetails?.finance === false
                                    ? "No"
                                    : "Yes"}
                                </span>
                              </div>{" "}
                            </Col>
                            <Col md={6}>
                              <div>
                                <span
                                  className="
                                 text-black fw-light"
                                >
                                  Replacement Report{" "}
                                </span>
                              </div>
                              <div className=" grey-color-light ">
                                {inspectionDetails?.replacement_report || "---"}{" "}
                              </div>{" "}
                            </Col>
                          </Row>
                        </Col>
                      </Row>

                      <div
                        className="d-flex align-items-center text-center "
                        style={{ marginTop: "1px" }}
                      >
                        <hr className="flex-grow-1 solid-line" />
                      </div>

                      <Row className="pt-3 mb-1">
                        {inspectionSections.map((section, secIdx) => {
                          // Get metrics for this section
                          const metrics =
                            inspectionDetails?.check_metrics?.[
                              section.checkMetricIndex
                            ]?.section?.parameters || []

                          if (!section.data || !section.data.length) return null

                          return (
                            <React.Fragment key={section.title}>
                              <h5
                                className={`${secIdx === 0 ? "mb-2" : "mt-2 mb-2"
                                  } text-black`}
                                style={{
                                  fontWeight: "700",
                                  fontSize: "18px",
                                  textTransform: "uppercase",
                                }}
                              >
                                {section.title}
                              </h5>
                              {section.isSub
                                ? // SubHead sections
                                section.data.map((sub, subHeadIdx) => (
                                  <div key={sub.title}>
                                    <h6
                                      className="mb-2 mt-2"
                                      style={{
                                        color: "#212B36",
                                        fontSize: "13px",
                                        fontWeight: "700",
                                      }}
                                    >
                                      {sub.title}
                                    </h6>
                                    {sub.item.map((item, itemIdx) => (
                                      <div
                                        key={itemIdx}
                                        style={{
                                          minWidth: isTablet ? 380 : 480,
                                          borderRadius: 6,
                                          paddingY: "8px",
                                        }}
                                        className="mb-2 d-flex align-items-center"
                                      >
                                        <div
                                          className="d-flex align-items-center "
                                          style={{
                                            minWidth: isTablet ? 380 : 480,
                                          }}
                                        >
                                          <p
                                            className="mb-0 "
                                            style={{ color: "#495057" }}
                                          >
                                            {/* Serial number logic if needed */}
                                            {/* {itemIdx + 1}. &nbsp; */}
                                            {getGlobalIndex(
                                              secIdx,
                                              subHeadIdx,
                                              itemIdx
                                            )}
                                            . &nbsp; {/* Serial number */}
                                          </p>
                                          <p
                                            className="mb-0 "
                                            style={{ color: "#495057" }}
                                          >
                                            {item}
                                          </p>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-center pt-1 w-100">
                                          <p
                                            className="pe-2 mb-0 text-black"
                                            style={{
                                              whiteSpace: "nowrap",
                                              marginTop: "2px",
                                            }}
                                          >
                                            &nbsp; Good
                                          </p>
                                          <div
                                            className=""
                                            style={{ marginBottom: "-2px" }}
                                          >
                                            <input
                                              type="checkbox"
                                              className="custom-green-checkbox single-view"
                                              checked={
                                                metrics?.[subHeadIdx]
                                                  ?.sub_parameters?.[itemIdx]
                                                  ?.status ?? false
                                              }
                                              disabled
                                              style={{
                                                width: "15px",
                                                height: "15px",
                                                accentColor: "#28a745",
                                              }}
                                            />
                                          </div>
                                          <div
                                            className="w-100 "
                                            style={{ marginLeft: "20px" }}
                                          >
                                            <div
                                              className="text-black"
                                              style={{
                                                width: "100%",
                                                borderBottom:
                                                  "1px solid #e0e0e0",
                                                // padding: "6px 0 2px 0",
                                                padding: metrics?.[subHeadIdx]
                                                  ?.sub_parameters?.[itemIdx]
                                                  ?.value
                                                  ? "0px 0px 0px 0px"
                                                  : "6px 0 2px 0",

                                                fontSize: "1em",
                                              }}
                                            >
                                              {metrics?.[subHeadIdx]
                                                ?.sub_parameters?.[itemIdx]
                                                ?.value ?? ""}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                ))
                                : // Flat sections
                                section.data.map((item, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      minWidth: isTablet ? 380 : 480,
                                      borderRadius: 6,
                                      paddingY: "8px",
                                    }}
                                    className="mb-2 d-flex align-items-center"
                                  >
                                    <div
                                      className="d-flex align-items-center "
                                      style={{
                                        minWidth: isTablet ? 380 : 480,
                                      }}
                                    >
                                      <p
                                        className="mb-0 "
                                        style={{ color: "#495057" }}
                                      >
                                        {/* {index + 1}. &nbsp; */}
                                        {getGlobalIndex(
                                          secIdx,
                                          undefined,
                                          index
                                        )}
                                        . &nbsp; {/* Serial number */}
                                      </p>
                                      <p
                                        className="mb-0 "
                                        style={{ color: "#495057" }}
                                      >
                                        {item}
                                      </p>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-center pt-1 w-100">
                                      <p
                                        className="pe-2 mb-0 text-black"
                                        style={{
                                          whiteSpace: "nowrap",
                                          marginTop: "2px",
                                        }}
                                      >
                                        &nbsp; Good
                                      </p>
                                      <div
                                        className=""
                                        style={{ marginBottom: "-2px" }}
                                      >
                                        <input
                                          type="checkbox"
                                          className="custom-green-checkbox single-view"
                                          checked={
                                            metrics?.[index]?.status ?? false
                                          }
                                          disabled
                                          style={{
                                            width: "15px",
                                            height: "15px",
                                            accentColor: "#28a745",
                                          }}
                                        />
                                      </div>
                                      <div
                                        className="w-100 "
                                        style={{ marginLeft: "20px" }}
                                      >
                                        <div
                                          className="text-black"
                                          style={{
                                            width: "100%",
                                            borderBottom: "1px solid #e0e0e0",
                                            padding: metrics?.[index]?.value
                                              ? "0px 0px 0px 0px"
                                              : "6px 0 2px 0",
                                            fontSize: "1em",
                                          }}
                                        >
                                          {metrics?.[index]?.value ?? ""}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                            </React.Fragment>
                          )
                        })}
                      </Row>




                      <div
                        className="d-flex align-items-center text-center "
                        style={{ marginTop: "1px" }}
                      >
                        <hr className="flex-grow-1 solid-line" />
                      </div>


                      <Row>
                        <Col md={6}>
                          <div>
                            <span
                              className="
                                 text-black fw-light"
                            >
                              Remarks{" "}
                            </span>
                          </div>
                          <div className=" grey-color-light ">
                            {inspectionDetails?.remarks || "---"}{" "}
                          </div>{" "}
                        </Col>
                      </Row>

                      <Row className="align-items-end mb-4 justify-content-end">
                        <img
                          src={verified}
                          alt="verified"
                          style={{
                            maxWidth: "120px",
                            height: "120px",
                            objectFit: "contain",
                            marginTop: "-20px",
                          }}
                        />
                      </Row>
                    </Container>
                  </div>
                </>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

InspectionDocumentDetails.propTypes = {
  user: PropTypes.object,
  match: PropTypes.any,
  onGetUserDetail: PropTypes.func,
}

export default InspectionDocumentDetails
